import { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

const TransaksiRealisasi = () => {
  const { api, periode } = useGlobalContext();

  const initialEditData = {
    jenis_pinjaman: "",
    saldo_pinjaman: 0,
    jumlah_pinjaman: 0,
    rencana_angsuran: 0,
    potongan_bulan: 0,    
    no_bkm: "",
    administrasi: 0,
    dpha: 0,
    terjurnal: "",
  };

  const initialFormData = {
    tglTransaksi: new Date().toISOString().split("T")[0],
    noRealisasi: "",
    noBkk: "",
    noAnggota: "",
    nama: "",
    unitkerja: "",
    terjurnal: "",
  };

  const [editData, setEditData] = useState(initialEditData);
  const [formData, setFormData] = useState(initialFormData);

  // ================== HANDLER ==================
  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "noAnggota" && value.trim() !== "") {
      fetchAnggotaData(value);
    }
  };

  const handleChangeFormEdit = (e) => {
    const { name, value } = e.target;

    // Handle dropdown jenis pinjaman
    if (name === "jenis_pinjaman") {
      setEditData((prev) => ({
        ...prev,
        jenis_pinjaman: value,
      }));

      if (value.trim() !== "" && formData.noAnggota) {
        fetchSaldoPinjaman(periode, formData.noAnggota, value);
      }
      return;
    }

    if (name === "no_bkm"){
      setEditData((prev) => ({
        ...prev,
        no_bkm: value,
      }));
      return;
    }

    // Handle input numerik
    const cleaned = value.replace(/[^\d]/g, "");
    const numericValue = parseFloat(cleaned) || 0;

    setEditData((prev) => {
      const updated = { ...prev, [name]: numericValue };

      // Hitung potongan per bulan otomatis
      if (name === "jumlah_pinjaman" || name === "rencana_angsuran") {
        const jumlah = parseFloat(updated.jumlah_pinjaman) || 0;
        const angsuran = parseFloat(updated.rencana_angsuran) || 0;

        updated.potongan_bulan =
          jumlah > 0 && angsuran > 0
            ? (jumlah / angsuran).toFixed(2)
            : 0;
      }

      return updated;
    });
  };

  // ================== FETCH DATA ==================
  const fetchAnggotaData = async (noAnggota) => {
    try {
      const response = await api.get(`/api/anggota/${noAnggota}`);
      setFormData((prev) => ({
        ...prev,
        nama: response.data.nama || "",
        unitkerja: response.data.unitkerja || "",
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSaldoPinjaman = async (periode, noAnggota, jenisPinjaman) => {
    try {
      const response = await api.get(
        `/api/piutang/findsaldo_jpg/${periode}/${noAnggota}`
      );
      if (response.status === 200 && response.data) {
        const saldo =
          jenisPinjaman === "A"
            ? response.data.sldunit_a
            : response.data.sldunit_b;
        setEditData((prev) => ({
          ...prev,
          saldo_pinjaman: saldo || 0,
        }));
      }
    } catch {
      console.log("error saldo pinjaman");
    }
  };

  // Generata No Transaksi
  const GenerateNoRealisasi = async () => {
    //const thperiode = periode.toString().substring(0, 4);
    try {
      const response = await api.get(
        `/api/transaksi/getnotransaksirealisasi/${periode}`
      );
      if (response.status === 200 && response.data.norealisasi!==null) {
        const currentNo = response.data.norealisasi;
        const [angka, , tahun] = currentNo.split("/");
        const nextAngka = (parseInt(angka) + 1).toString().padStart(4, "0");
        setFormData((prev) => ({
          ...prev,
          noRealisasi: `${nextAngka}/R/${tahun}`,
        }));
      } else {

        setFormData((prev) => ({
          ...prev,
          noRealisasi: `0001/R/${periode}`,
        }));
      }
    } catch {
      setFormData((prev) => ({
        ...prev,
        noRealisasi: `0001/R/${periode}`,
      }));
    }
  };

  // Format Number
  const formatNumber = (number) =>
    !number ? "0" : Number(number).toLocaleString("id-ID");

  // Reset Form
  const handleReset = () => {    
    setEditData((prev) => ({      
      ...prev,
      saldo_pinjaman: 0,
      jumlah_pinjaman: 0,
      rencana_angsuran: 0,
      potongan_bulan: 0,
      no_bkm: "",
      administrasi: 0,
      dpha: 0,
      terjurnal: "",
    }));

    setFormData((prev) => ({
      ...prev,
      noRealisasi: "",
      noBkk: "",
      noAnggota: "",
      nama: "",
      unitkerja: "",
      terjurnal: "",
    }));
  };

  // Submit Data
  const handleSubmit = async () => {
    try {
      const payload = {
        norealisasi: formData.noRealisasi,
        tanggal: formData.tglTransaksi,
        noanggota: formData.noAnggota,
        jenispin: editData.jenis_pinjaman,
        saldolalu: editData.saldo_pinjaman,
        pinjaman: editData.jumlah_pinjaman,
        xangsur: editData.rencana_angsuran,
        angsuran: editData.potongan_bulan,
        administrasi: editData.administrasi,
        dpha: editData.dpha,
        nobkm: editData.no_bkm,
        nobkk: formData.noBkk,
        terjurnal: 0,
        tglentri: new Date(),
      };

      const date = new Date(formData.tglTransaksi);
      const yyyymm = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}`;

      if (yyyymm !== periode) {
        alert(`Tanggal transaksi tidak sesuai dengan periode`);      
        handleReset();
        return;
      }

      // 1. Validasi No Anggota 
      if (!formData.noAnggota || formData.noAnggota.trim() === "") { 
        alert("⚠️ No. Anggota harus diisi!"); 
        return; 
      } 
      // Cek apakah No Anggota ditemukan 
      if (!formData.nama || formData.nama.trim() === "") { 
        alert("⚠️ No. Anggota tidak ditemukan!"); 
        return; 
      } 
      
      // 2. Validasi Jenis Pinjaman 
      if (!editData.jenis_pinjaman || editData.jenis_pinjaman.trim() === "") { 
        alert("⚠️ Jenis pinjaman harus dipilih!"); 
        return; 
      } 
      
      // 3. Validasi Jumlah Pinjaman 
      const jumlahPinjaman = parseFloat(editData.jumlah_pinjaman) || 0; 
      if (jumlahPinjaman <= 0) { 
        alert("⚠️ Jumlah pinjaman harus lebih dari 0!"); 
        return; 
      } 
      
      // 4. Validasi Rencana Angsuran 
      const rencanaAngsuran = parseFloat(editData.rencana_angsuran) || 0; 
      if (rencanaAngsuran <= 0) { 
        alert("⚠️ Rencana angsuran harus lebih dari 0!"); 
        return; 
      }

      // 5. Validasi Sisa Piutang (Unit D / Jenis A)
      const sisaPiutang = parseFloat(editData.saldo_pinjaman) || 0;
      if (editData.jenis_pinjaman === "A" && sisaPiutang > 0) {
        alert(
          "⚠️ Realisasi tidak bisa disimpan! Pinjaman (Unit D) masih memiliki sisa piutang."
        );
        return;
      }
      console.log(`${editData.jenis_pinjaman}`);
      const response = await api.patch(`/api/piutang/updatestatus/${formData.noAnggota}/${editData.jenis_pinjaman}`);
      if (response.status === 200 || response.status === 201) {
        try {
          const response = await api.post("/api/piutang/realisasipinjaman", payload);
          alert("✅ Realisasi pinjaman berhasil disimpan!");
        } catch (statusError) {
          alert("⚠️ Gagal menyimpan realisasi pinjaman.");          
        }
        handleReset(); 
      }      
    } catch (error) {
      console.error("❌ Gagal simpan realisasi:", error);
      alert("Terjadi kesalahan saat menyimpan data!");
    }
  };

  // ================== RENDER ==================
  return (
    <div className="container" style={{ maxWidth: "800px" }}>
      <div className="card card-info">
        <div className="card-header">
          <h3 className="card-title"><b>Transaksi Realisasi</b></h3>
        </div>        
        <div className="card-body">
          {/* === FORM === */}
          <div className="row mb-2 align-items-center">
            <label className="col-md-2 fw-bold">Tanggal</label>
            <div className="col-md-3">
              <input
                type="date"
                className="form-control"
                name="tglTransaksi"
                value={formData.tglTransaksi}
                onChange={handleChangeForm}
              />
            </div>
          </div>

          <div className="row mb-2 align-items-center">
            <label className="col-md-2 fw-bold">No. Realisasi</label>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                name="noRealisasi"
                value={formData.noRealisasi}
                readOnly
              />
            </div>
            <div className="col-auto">
              <button
                className="btn btn-primary"
                type="button"
                onClick={GenerateNoRealisasi}
              >
                Click
              </button>
            </div>
          </div>

          {/* === Data Anggota === */}
          <div className="row mb-2 align-items-center">
            <label className="col-md-2 fw-bold">No. Anggota</label>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control"
                name="noAnggota"
                value={formData.noAnggota}
                onChange={handleChangeForm}
              />
            </div>
          </div>

          <div className="row mb-2 align-items-center">
            <label className="col-md-2 fw-bold">Nama</label>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                value={formData.nama}
                disabled
              />
            </div>
          </div>

          <div className="row mb-2 align-items-center">
            <label className="col-md-2 fw-bold">Unit Kerja</label>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                value={formData.unitkerja}
                disabled
              />
            </div>
          </div>

          {/* === BAGIAN PINJAMAN === */}
          <div className="card mt-3">
            <div className="card-header fw-bold">Pinjaman</div>
            <div className="card-body">
              {/* Jenis Pinjaman */}
              <div className="row mb-2">
                <label className="col-md-3 fw-bold">1. Jenis Pinjaman</label>
                <div className="col-md-3">
                  <select
                    name="jenis_pinjaman"
                    className="form-control"
                    value={editData.jenis_pinjaman}
                    onChange={handleChangeFormEdit}
                  >
                    <option value="">-- Pilih --</option>
                    <option value="A">Unit D</option>
                    <option value="B">Unit C</option>
                  </select>
                </div>
              </div>

              {/* Saldo Pinjaman */}
              <div className="row mb-2">
                <label className="col-md-3 fw-bold">2. Saldo Pinjaman</label>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    name="saldo_pinjaman"
                    value={formatNumber(editData.saldo_pinjaman)}
                    readOnly
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>

              {/* Jumlah Pinjaman */}
              <div className="row mb-2">
                <label className="col-md-3 fw-bold">3. Jumlah Pinjaman</label>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    name="jumlah_pinjaman"
                    value={formatNumber(editData.jumlah_pinjaman)}
                    onChange={handleChangeFormEdit}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>

              {/* Rencana Angsuran */}
              <div className="row mb-2">
                <label className="col-md-3 fw-bold">4. Rencana Angsuran</label>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    name="rencana_angsuran"
                    value={formatNumber(editData.rencana_angsuran)}
                    onChange={handleChangeFormEdit}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>

              {/* Potongan Bulan */}
              <div className="row mb-2">
                <label className="col-md-3 fw-bold">5. Potongan / Bulan</label>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    name="potongan_bulan"
                    value={formatNumber(editData.potongan_bulan)}
                    onChange={handleChangeFormEdit}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* === BAGIAN POTONGAN === */}
          <div className="card mt-3">
            <div className="card-header fw-bold">Potongan</div>
            <div className="card-body">
              <div className="row mb-2 align-items-center">
                <label className="col-md-3 fw-bold">No. BKM</label>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    name="no_bkm"
                    value={editData.no_bkm}
                    onChange={handleChangeFormEdit}                    
                  />
                </div>
              </div>

              <div className="row mb-2 align-items-center">
                <label className="col-md-3 fw-bold">Administrasi</label>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    name="administrasi"
                    value={formatNumber(editData.administrasi)}
                    onChange={handleChangeFormEdit}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>

              <div className="row mb-2 align-items-center">
                <label className="col-md-3 fw-bold">DPHA</label>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    name="dpha"
                    value={formatNumber(editData.dpha)}
                    onChange={handleChangeFormEdit}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* === TOMBOL AKSI === */}
          <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleSubmit}>
            Simpan
          </button>
          <button className="btn btn-secondary" onClick={handleReset}>
            Batal
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default TransaksiRealisasi;
